<ng-container *ngIf="pageTitle">
  <div
    class="page-title"
    [ngClass]="{
      'title ms-0 col-12 p-md-0': isDigitalCartTemplateEnabled,
      'page-title': !isDigitalCartTemplateEnabled,
    }"
    [class.gray-bg]="grayBackground"
    id="page-title"
  >
    <div
      [ngClass]="{
        container: !isDigitalCartTemplateEnabled,
        digitalTitle: isDigitalCartTemplateEnabled,
      }"
    >
      <h2
        *ngIf="!accountPage && !grayBackground && !isDigitalCartTemplateEnabled"
        #pageHeading
        class="m-t-xl"
        [ngClass]="{ 'm-b-xl': !heading }"
        [attr.aria-label]="pageTitle"
      >
        {{ pageTitle }}
      </h2>
      <div
        *ngIf="isDigitalCartTemplateEnabled"
        [ngClass]="{ cartTitle: !isDigitalCartTemplateEnabled }"
      >
        <div [ngClass]="{ digitalTitle: !isDigitalCartTemplateEnabled }">
          <h4 *ngIf="!accountPage && !grayBackground" #pageHeading id="title" class="m-t-xl">
            {{ digitalPageTitle }}
          </h4>
          <p class="small m-b-xl">{{ digitalSubTitle }}</p>
        </div>
      </div>
      <h1
        *ngIf="!accountPage && grayBackground"
        #pageHeading
        class="m-t-xl"
        [ngClass]="{ 'm-b-xl': !heading }"
        [attr.aria-label]="pageTitle"
      >
        {{ pageTitle }}
      </h1>
      <ng-content></ng-content>
      <p
        *ngIf="!accountPage && heading !== undefined"
        class="lead m-t-xs m-b-md"
        [attr.aria-label]="heading"
      >
        {{ heading }}
      </p>
      <div
        class="row m-t-xxl xs-m-t-xl xs-m-b-sm"
        [ngClass]="{ 'm-b-xl': !isP10MCustomer }"
        *ngIf="accountPage"
      >
        <h1
          *ngIf="grayBackground"
          class="col-12 col-md-8 col-lg-8 title-wrapper"
          [attr.aria-label]="pageTitle"
        >
          {{ pageTitle }}
        </h1>
        <div *ngIf="accountPage && !grayBackground" class="col-12 col-md-7 col-lg-8 title-wrapper">
          <h3 *ngIf="!isP10MCustomer" [attr.aria-label]="pageTitle">{{ pageTitle }}</h3>
          <h2 *ngIf="isP10MCustomer" [attr.aria-label]="pageTitle">{{ pageTitle }}</h2>
          <p
            *ngIf="accountPage && heading !== undefined && isP10MCustomer"
            class="lead m-t-xs m-b-md"
            [attr.aria-label]="heading"
          >
            {{ heading }}
          </p>
        </div>
        <div class="col-12 col-md-4" [ngClass]="numAlerts > 0 ? 'account-section' : 'sm-m-t-md'">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 account-info">
              <p class="small bold">{{ accountText }} {{ symbolConstant.HASH }} {{ accountId }}</p>
            </div>
            <div
              *ngIf="numAlerts >= 0"
              class="col-md-12 col-sm-12 col-xs-12 n-padding-l account-alert"
            >
              <p>
                <a
                  class="notification-button"
                  [ngClass]="{ disabled: numAlerts === 0 }"
                  (click)="toggleAlerts()"
                  tabindex="{{ numAlerts === 0 ? -1 : 0 }}"
                  href="javascript:void(0)"
                  id="cta-default-214"
                >
                  <i class="notification-icon" [class.no-notification]="numAlerts === 0"></i>
                  <span *ngIf="numAlerts" class="circle alerts-count">{{ numAlerts }}</span>
                  <span class="notification-text m-l-md">{{ alertSuffix }}</span>
                  <i class="fa carret fa-angle-down" *ngIf="numAlerts && !alertsExpanded"></i>
                  <i class="fa carret fa-angle-up" *ngIf="numAlerts && alertsExpanded"></i>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isDigitalCartTemplateEnabled" tmoTitleHeaderSpacing></div>
  <ng-container *ngIf="!isFractionalPage">
    <tmo-global-error-message
      [isFractionalPage]="isFractionalPage"
      id="error-message-detail"
    ></tmo-global-error-message>
  </ng-container>
</ng-container>
